var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2771.97 2791.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#18174a;}.cls-3{fill:#2b69b3;}.cls-4{fill:#91b3fa;}.cls-5{fill:#fff;}.cls-6{opacity:0.6;}.cls-7{opacity:0.24;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{opacity:0.3;}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:#7d97f4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2018.71,
    y1: -892.63,
    x2: -459.37,
    y2: 2184.98,
    gradientTransform: "matrix(1, 0, 0, -1, 1164.42, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 796.89,
    y1: 2192.01,
    x2: 813.15,
    y2: 2192.01,
    gradientTransform: "matrix(1, 0, 0, -1, 1164.42, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 781.44,
    y1: 1897.3,
    x2: 1428.55,
    y2: 1897.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1445.23,
    y1: 1712.92,
    x2: 1467.39,
    y2: 1712.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1633.08,
    y1: 1987.03,
    x2: 1648.46,
    y2: 1987.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 990.73,
    y1: 2264.08,
    x2: 1655.67,
    y2: 2264.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 953.53,
    y1: 2419.41,
    x2: 975.41,
    y2: 2419.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1585.4,
    y1: 2728.21,
    x2: 1082.36,
    y2: 1822.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 404.22,
    y1: 2526.5,
    x2: 414.17,
    y2: 2526.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 395.58,
    y1: 2349.36,
    x2: 785.32,
    y2: 2349.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 794.39,
    y1: 2237.58,
    x2: 809.55,
    y2: 2237.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 910.29,
    y1: 2405.49,
    x2: 919.48,
    y2: 2405.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 522.89,
    y1: 2571.87,
    x2: 923.32,
    y2: 2571.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 499.62,
    y1: 2666.11,
    x2: 514.53,
    y2: 2666.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -8570.99,
    y1: 18.63,
    x2: -8361.18,
    y2: 18.63,
    gradientTransform: "matrix(1, 0, 0, -1, 9033.48, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -8551.62,
    y1: 117.19,
    x2: -8492.51,
    y2: 117.19,
    gradientTransform: "matrix(1, 0, 0, -1, 9033.48, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -8883.59,
    y1: 147.99,
    x2: -8813.01,
    y2: 147.99,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -7911.97,
    y1: 1635.96,
    x2: -8191.75,
    y2: 1271.98,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -46.99,
    y1: 2571.99,
    x2: -424.25,
    y2: 1661.52,
    gradientTransform: "matrix(1, 0, 0, -1, 1164.42, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 203.51,
    y1: 2846.91,
    x2: -889.77,
    y2: 492.67,
    gradientTransform: "matrix(1, 0, 0, -1, 1164.42, 2720.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -8535.6,
    y1: 1400.72,
    x2: -8504.99,
    y2: 1561.41,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -8452.76,
    y1: 1695.54,
    x2: -8627.4,
    y2: 1561.92,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -8474.43,
    y1: 1723.84,
    x2: -8649.06,
    y2: 1590.22,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 327.81,
    y1: 2328.78,
    x2: 99.77,
    y2: 1876.04,
    gradientTransform: "matrix(1, 0, 0, -1, 1164.42, 2720.72)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -8405.16,
    y1: 1226.36,
    x2: -8505.37,
    y2: 1076.05,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 4627.82,
    y1: 1202.09,
    x2: 4529.62,
    y2: 1054.79,
    gradientTransform: "translate(5056.2 2720.72) rotate(180)",
    xlinkHref: "#linear-gradient-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2501.39,2399.65c-56.92,59.93-110.77,98.57-153.33,129.1-500.18,358.89-1092,254.28-1217.82,228.73-185.75-37.76-544.79-110.65-804.37-415.91C-66.86,1879.72-5.71,1152.12,298.92,671.81,354.63,584,649,96.33,1247.2,18.13c362-47.32,784.07,48.13,1089.68,304.18C2978.4,859.77,2932.73,1945.55,2501.39,2399.65Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1046.01 1982.1 979.14 2581.79 1754.91 2581.79 1653.87 1982.1 1046.01 1982.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1972.74,2704.49H837.35c-30.85,0-54-22-48.05-45.55l14.57-57.61c4.38-17.33,23.45-30,46.09-30.76l1094.56-34.15c23.65-.74,44.6,11.81,49.75,29.82l26.27,91.77C2027.36,2681.86,2004.09,2704.49,1972.74,2704.49Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.54,688.46V2061.91a208.32,208.32,0,0,0,203,208.29c501.65,12.94,1793.71,44.3,2271.25,37.26a153.3,153.3,0,0,0,150.93-148.94c9.21-319.07,24.17-1086.33-31.18-1442.53a157.74,157.74,0,0,0-150.91-133.54C2146.36,569,748.91,526.31,271.63,537A151.45,151.45,0,0,0,123.54,688.46Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.72,681.78V1986.65a120.73,120.73,0,0,0,118.91,120.7l2200.44,32.9a117.48,117.48,0,0,0,119.23-115.71c0-.43,0-.86,0-1.29L2652.76,730a85.91,85.91,0,0,0-83.83-86.21L305.08,588.72a93.09,93.09,0,0,0-95.33,90.79C209.73,680.27,209.72,681,209.72,681.78Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2668.36,2193.44h-.07L209.63,2143.72a3.41,3.41,0,0,1,.14-6.81l2458.63,49.77a3.41,3.41,0,0,1-.06,6.81Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1448.55,2585.88a3.41,3.41,0,0,1,0-6.81l46.91-.68h0a3.41,3.41,0,0,1,0,6.81Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.34,2672.43a4.86,4.86,0,0,1-.54,0,3.42,3.42,0,0,1-2.83-3.9l6.7-41.91a46.45,46.45,0,0,1,45.26-39.19l497.48-7.28a3.56,3.56,0,0,1,3.46,3.36,3.41,3.41,0,0,1-3.36,3.45L880,2594.24a39.65,39.65,0,0,0-38.64,33.45l-6.69,41.91A3.41,3.41,0,0,1,831.34,2672.43Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 441.69,
    cy: 799.97,
    r: 41.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 492.41,
    cy: 1017.9,
    r: 41.19,
    transform: "translate(-641.97 1340.86) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 492.42,
    cy: 1235.83,
    r: 41.19,
    transform: "translate(-857.07 1523.87) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 492.4,
    cy: 1453.69,
    r: 41.19,
    transform: "translate(-569.55 299.09) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 441.67,
    cy: 1695.45,
    r: 41.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 441.67,
    cy: 1913.37,
    r: 41.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 584.36,
    y: 638.92,
    width: 47.67,
    height: 1453.93,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 700.12,
    y: 904.51,
    width: 1215.58,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 700.12,
    y: 1059.04,
    width: 450.59,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1994.02,
    y: 1364.47,
    width: 450.59,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1394.42,
    y: 1516.12,
    width: 450.59,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1224.49,
    y: 1654.26,
    width: 278.07,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 717.15,
    y: 1780.25,
    width: 278.07,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 717.15,
    y: 1654.26,
    width: 450.59,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1563.86,
    y: 1654.26,
    width: 744.56,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1735.24,
    y: 1211.94,
    width: 652.62,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 700.12,
    y: 1516.12,
    width: 652.62,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1210.87,
    y: 1059.04,
    width: 974.96,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 700.12,
    y: 1211.94,
    width: 974.96,
    height: 47.67,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 700.12,
    y: 1364.47,
    width: 1215.58,
    height: 47.67,
    rx: 4.44
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M878.68,823l-50.75-37.63,1-11.85,56.32-28.45-1.44,17.09L845,780.86l35.13,25.07Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M956.88,733.77,906.13,841.32l-19.44-1.6,50.75-107.55Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M959.26,812.6l39.07-18.81L963,768.85l1.44-17.09,50.77,37.48-1,11.85-56.34,28.63Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835,1990.85l-50.75-37.63,1-11.85,56.37-28.45L840.19,1930l-38.88,18.71,35.14,25Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M913.21,1901.6l-50.76,107.54L843,2007.51,893.76,1900Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M915.63,1980.43l39-18.82-35.35-24.89,1.44-17.09,50.76,37.48-1,11.85-56.33,28.6Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1971,517.06a6.66,6.66,0,0,0-6.42,4.72q-1.57,5.16-3,10.37a6.65,6.65,0,0,0,12.81,3.55q1.39-5.06,2.92-10.05a6.64,6.64,0,0,0-4.42-8.29h0A6.65,6.65,0,0,0,1971,517.06Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1961.34,561a6.64,6.64,0,0,1,5.29,7.76v0c-1.3,6.81-2.46,13.75-3.42,20.64a6.65,6.65,0,0,1-13.19-1.72.59.59,0,0,0,0-.13c1-7.11,2.19-14.27,3.54-21.3a6.65,6.65,0,0,1,6.58-5.39A5.93,5.93,0,0,1,1961.34,561Zm-7.71,55.23a6.63,6.63,0,0,1,6.24,7c-.41,6.93-.65,14-.72,20.92a6.65,6.65,0,0,1-6.71,6.58h0a6.65,6.65,0,0,1-6.58-6.71c.07-7.17.32-14.43.74-21.58a6.66,6.66,0,0,1,6.7-6.25Zm6.53,62c.48,6.94,1.13,14,2,20.84a6.65,6.65,0,0,1-13.14,2c0-.15,0-.3-.06-.46-.84-7.1-1.52-14.33-2-21.48a6.65,6.65,0,0,1,6.16-7.09h.54a6.65,6.65,0,0,1,6.45,6.12Zm7.28,54.41c1.36,6.8,2.91,13.66,4.61,20.41a6.65,6.65,0,0,1-12.78,3.66c0-.14-.08-.27-.11-.41-1.75-7-3.35-14-4.75-21a6.64,6.64,0,0,1,5.2-7.82h0a7,7,0,0,1,1.37-.13,6.66,6.66,0,0,1,6.4,5.24Zm14.25,53c2.23,6.57,4.66,13.18,7.23,19.64a6.65,6.65,0,0,1-12.36,4.9c-2.64-6.66-5.15-13.48-7.46-20.26a6.66,6.66,0,0,1,4.16-8.43,6.85,6.85,0,0,1,2.2-.36,6.65,6.65,0,0,1,6.17,4.47Zm21,50.72c3.08,6.23,6.35,12.48,9.74,18.56a6.65,6.65,0,0,1-11.37,6.9l-.24-.43c-3.5-6.28-6.88-12.72-10-19.14a6.64,6.64,0,1,1,11.9-5.9h0ZM2030.16,884c3.86,5.78,7.92,11.54,12.06,17.13a6.65,6.65,0,1,1-10.37,8.32c-.11-.13-.21-.27-.31-.41-4.27-5.76-8.46-11.7-12.43-17.66a6.64,6.64,0,0,1,11.05-7.38Zm33.4,43.62c4.57,5.23,9.34,10.42,14.15,15.42a6.64,6.64,0,1,1-9.56,9.23h0c-5-5.15-9.89-10.51-14.61-15.91a6.65,6.65,0,0,1,9.54-9.27,5.82,5.82,0,0,1,.46.53Zm38.72,38.94c5.21,4.61,10.59,9.14,16,13.47a6.65,6.65,0,0,1-8.3,10.38c-5.59-4.47-11.14-9.14-16.52-13.89a6.66,6.66,0,0,1,8.81-10Zm43.39,33.64c5.75,3.89,11.68,7.69,17.6,11.29a6.65,6.65,0,0,1-6.9,11.36c-6.11-3.71-12.22-7.63-18.15-11.64a6.65,6.65,0,0,1,7.45-11Zm446.51,25.24a6.64,6.64,0,0,1-2.72,9c-6.33,3.39-12.82,6.67-19.27,9.73a6.65,6.65,0,0,1-5.7-12c6.26-3,12.55-6.14,18.69-9.43a6.63,6.63,0,0,1,9,2.71h0ZM2193,1027.93c6.2,3.11,12.56,6.11,18.9,8.92a6.64,6.64,0,1,1-5.38,12.15h0c-6.54-2.88-13.1-6-19.49-9.19a6.65,6.65,0,1,1,6-11.88h0Zm348.76,21.37a6.65,6.65,0,0,1-3.86,8.57c-6.69,2.53-13.55,4.93-20.39,7.14a6.65,6.65,0,0,1-4.08-12.66h0c6.63-2.13,13.28-4.46,19.76-6.91a7,7,0,0,1,2.42-.44,6.64,6.64,0,0,1,6.13,4.26Zm-298.26,0c6.57,2.29,13.26,4.44,19.88,6.39a6.65,6.65,0,0,1-3.75,12.75c-6.83-2-13.73-4.23-20.5-6.59a6.64,6.64,0,0,1,4.37-12.55Zm245.12,17.09a6.64,6.64,0,0,1-4.92,8h0c-7,1.65-14.11,3.13-21.14,4.43a6.65,6.65,0,0,1-2.61-13l.21,0c6.82-1.25,13.71-2.69,20.49-4.29a7.11,7.11,0,0,1,1.59-.18A6.65,6.65,0,0,1,2488.63,1066.39Zm-192.3-2.45c6.76,1.41,13.69,2.67,20.58,3.75a6.65,6.65,0,0,1-2.06,13.13c-7.11-1.11-14.25-2.42-21.23-3.87a6.64,6.64,0,0,1,1.41-13.15,6.43,6.43,0,0,1,1.32.14Zm137.43,12.54a6.65,6.65,0,0,1-5.93,7.29c-6.25.64-12.58,1.15-18.82,1.52l-2.72.15a6.64,6.64,0,1,1-.69-13.27h0l2.61-.15c6.06-.36,12.21-.86,18.27-1.48h.74a6.63,6.63,0,0,1,6.56,5.94Zm-83.08-4.89c6.92.52,14,.88,20.9,1.05a6.65,6.65,0,0,1-.34,13.3c-7.16-.19-14.41-.55-21.56-1.09a6.65,6.65,0,0,1,.55-13.28Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2625.22,998.29a6.54,6.54,0,0,0-3.8,1.15q-4.32,2.94-8.72,5.78a6.65,6.65,0,0,0,7.21,11.17q4.53-2.92,9-6a6.65,6.65,0,0,0-3.68-12.14Z",
    transform: "translate(-50.73 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2806.29,721.72a6.64,6.64,0,0,0-6.59,5.42q-1,5.16-2,10.26a6.65,6.65,0,0,0,12.91,3.23c0-.16.07-.31.09-.46q1.14-5.28,2.11-10.58a6.61,6.61,0,0,0-5.27-7.75A6,6,0,0,0,2806.29,721.72Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2391.51,211.72a6.65,6.65,0,1,1-.18,13.3h0l-3.84-.06c-5.54,0-11.19,0-16.78.17a6.65,6.65,0,0,1-.39-13.29c5.76-.17,11.58-.23,17.31-.17Zm34.46,2c7,.69,14.12,1.56,21.08,2.58a6.65,6.65,0,0,1-1.49,13.22l-.45-.07c-6.74-1-13.62-1.83-20.44-2.49a6.65,6.65,0,0,1,.7-13.27Zm-82.82,6.39a6.63,6.63,0,0,1-5.86,7.32h0c-6.79.73-13.67,1.64-20.44,2.7a6.65,6.65,0,0,1-2.21-13.11l.16,0c7-1.09,14.06-2,21.06-2.78q.39,0,.78,0a6.63,6.63,0,0,1,6.54,5.92ZM2481,222.72c6.88,1.58,13.81,3.34,20.59,5.25a6.65,6.65,0,0,1-3.61,12.8c-6.57-1.85-13.28-3.57-20-5.09a6.65,6.65,0,0,1,1.54-13.13A6.28,6.28,0,0,1,2481,222.72Zm-192.06,5.93a6.64,6.64,0,0,1-4.92,8c-6.67,1.59-13.37,3.37-19.92,5.27a6.65,6.65,0,0,1-3.72-12.76c6.76-2,13.67-3.8,20.55-5.44a6.75,6.75,0,0,1,1.61-.19,6.67,6.67,0,0,1,6.4,5.1Zm245.45,10c6.59,2.43,13.22,5.07,19.7,7.83a6.65,6.65,0,0,1-5.21,12.23c-6.28-2.68-12.71-5.23-19.1-7.59a6.65,6.65,0,0,1,2.37-12.89,6.56,6.56,0,0,1,2.24.39ZM2236.17,244a6.64,6.64,0,0,1-3.84,8.57h0c-6.41,2.43-12.82,5.05-19.07,7.79a6.65,6.65,0,0,1-5.33-12.19c6.45-2.81,13.07-5.52,19.68-8a6.65,6.65,0,0,1,8.57,3.86Zm349.06,17.24c6.22,3.25,12.47,6.71,18.56,10.29a6.65,6.65,0,1,1-6.36,11.68l-.36-.21c-5.91-3.47-12-6.82-18-10a6.65,6.65,0,0,1,6.16-11.79h0ZM2185.86,266a6.64,6.64,0,0,1-2.72,9c-6,3.23-12.06,6.65-17.93,10.17a6.64,6.64,0,0,1-6.83-11.4h0c6-3.64,12.27-7.16,18.48-10.48a6.67,6.67,0,0,1,9,2.68Zm447,24.17c5.78,4,11.54,8.25,17.11,12.56a6.64,6.64,0,0,1-8.12,10.52c-5.41-4.17-11-8.27-16.6-12.18a6.65,6.65,0,0,1,3.88-12.1,6.51,6.51,0,0,1,3.72,1.17Zm43.59,34.7c5.22,4.73,10.4,9.65,15.39,14.63a6.65,6.65,0,0,1-9.38,9.42c-4.85-4.84-9.87-9.61-14.94-14.19a6.65,6.65,0,0,1,8.93-9.86Zm38.86,40c4.59,5.36,9.11,10.9,13.42,16.48a6.64,6.64,0,1,1-10.5,8.14h0c-4.19-5.4-8.57-10.77-13-16a6.65,6.65,0,0,1,10.1-8.65Zm33.49,44.57c3.88,5.91,7.66,12,11.23,18.06a6.65,6.65,0,0,1-11.46,6.74c-3.46-5.89-7.13-11.78-10.89-17.51a6.66,6.66,0,0,1,1.92-9.2,6.51,6.51,0,0,1,3.7-1.09,6.64,6.64,0,0,1,5.49,2.92Zm27.55,48.49c3.09,6.35,6.06,12.87,8.84,19.37a6.65,6.65,0,0,1-12.23,5.21c-2.69-6.29-5.57-12.61-8.56-18.77a6.65,6.65,0,0,1,3.07-8.88h0a6.52,6.52,0,0,1,3-.67,6.66,6.66,0,0,1,5.87,3.66Zm21.11,51.62c2.24,6.66,4.35,13.49,6.27,20.3a6.64,6.64,0,1,1-12.79,3.61c-1.87-6.6-3.91-13.22-6.08-19.68a6.63,6.63,0,0,1,4.16-8.4h0a6.47,6.47,0,0,1,2.18-.35,6.63,6.63,0,0,1,6.23,4.45Zm14.32,53.85c1.37,6.91,2.59,14,3.62,20.93a6.65,6.65,0,0,1-13.15,2c-1-6.76-2.18-13.59-3.51-20.3a6.64,6.64,0,0,1,5.2-7.81h0a7,7,0,0,1,1.37-.13,6.65,6.65,0,0,1,6.44,5.23Zm7.35,55.23c.1,1.44.19,2.88.28,4.32.33,5.62.56,11.31.68,16.89a6.65,6.65,0,0,1-13.29.29c-.11-5.42-.34-10.93-.66-16.38l-.27-4.21a6.65,6.65,0,0,1,6.17-7.09h.53a6.65,6.65,0,0,1,6.55,6.1Zm-5.9,48.71a6.65,6.65,0,0,1,6.26,7c-.4,7.05-1,14.17-1.72,21.17a6.65,6.65,0,0,1-13.26-1c0-.13,0-.27,0-.4.72-6.78,1.28-13.69,1.67-20.53a6.65,6.65,0,0,1,6.69-6.27Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2133.22,291.52a6.56,6.56,0,0,0-3.92,1.23q-4.4,3.13-8.7,6.38a6.65,6.65,0,0,0,8,10.63q4.18-3.15,8.44-6.19a6.64,6.64,0,0,0-3.8-12.05Z",
    transform: "translate(-50.73 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2104.48,469.43a5.18,5.18,0,0,0-.44,6l32.59,53.77A274.33,274.33,0,0,0,2110.27,614L2053,639.79a5.17,5.17,0,0,0-3,5.18l6.89,75.13a5.15,5.15,0,0,0,3.91,4.54l61.05,15a274,274,0,0,0,41.34,78.54L2140.89,877a5.21,5.21,0,0,0,1.53,5.81l58,48.24a5.17,5.17,0,0,0,6,.45l53.79-32.6A273.84,273.84,0,0,0,2345,925.27l25.83,57.3a5.19,5.19,0,0,0,5.19,3l75.12-6.89a5.17,5.17,0,0,0,4.55-3.91l15-61a273.83,273.83,0,0,0,78.54-41.34L2608,894.69a5.17,5.17,0,0,0,5.8-1.52l48.25-58a5.17,5.17,0,0,0,.45-6l-32.6-53.79a273.84,273.84,0,0,0,26.37-84.75l57.23-25.91a5.16,5.16,0,0,0,3-5.18l-6.88-75.08a5.18,5.18,0,0,0-3.92-4.55l-61-15a274,274,0,0,0-41.35-78.54l22.27-58.8a5.16,5.16,0,0,0-1.53-5.8l-58-48.25a5.16,5.16,0,0,0-6-.45l-53.78,32.65a274.08,274.08,0,0,0-84.76-26.37l-25.83-57.3a5.18,5.18,0,0,0-5.18-3l-75.13,6.89a5.19,5.19,0,0,0-4.54,3.92l-15,61a274,274,0,0,0-78.54,41.34l-58.82-22.26a5.17,5.17,0,0,0-5.81,1.53Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2394.46,580.85a72,72,0,1,1-10.69-.89A75,75,0,0,1,2394.46,580.85Zm25.09,121.27a61.66,61.66,0,0,0-26.74-110.76h0a61.67,61.67,0,1,0-19.18,121.84h0a62,62,0,0,0,9.12.76,61.19,61.19,0,0,0,36.8-11.84Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2386.28,468.72a186.56,186.56,0,0,0-18.76.77h0c-2.52.23-5,.51-7.52.84a186.67,186.67,0,0,0-25.95,5.35l-.72.2c-1.47.42-2.92.86-4.37,1.31a2.68,2.68,0,0,0-1.87,2.51,2.86,2.86,0,0,0,.12.82,2.67,2.67,0,0,0,3.34,1.75,179.9,179.9,0,0,1,37.45-7.49h0A179.54,179.54,0,0,1,2562.14,629.3c.34,2.55.63,5.13.87,7.72a179.16,179.16,0,0,1-162.24,195c-98.5,9-186-63.75-195-162.24a179.74,179.74,0,0,1,16.86-94.08,2.66,2.66,0,0,0-4.79-2.3,184.68,184.68,0,0,0-17.4,96.83c9.3,101.41,99.37,176.38,200.79,167a184.74,184.74,0,0,0,167.83-181.8,188.37,188.37,0,0,0-.78-19C2559.63,541.42,2479.81,469.59,2386.28,468.72Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1574.91,186.09a3.7,3.7,0,0,0-3.58,2.63q-1.36,4.5-2.57,9a3.7,3.7,0,1,0,7.16,1.9h0q1.18-4.43,2.5-8.78a3.68,3.68,0,0,0-3.51-4.78Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1568.87,213.45a3.7,3.7,0,0,1,3,4.28v.05c-1.14,6.05-2.07,12.24-2.76,18.37a3.71,3.71,0,1,1-7.39-.66c0-.06,0-.12,0-.18.71-6.31,1.67-12.67,2.85-18.91a3.72,3.72,0,0,1,3.67-3A3.08,3.08,0,0,1,1568.87,213.45Zm-4.8,37.38a3.71,3.71,0,0,1,3.56,3.85v0c-.11,2.67-.18,5.36-.2,8q-.06,5.25.11,10.54a3.71,3.71,0,0,1-7.4.54c0-.11,0-.21,0-.32q-.15-5.43-.12-10.83,0-4.15.21-8.28a3.71,3.71,0,0,1,3.74-3.56Zm4.7,41c.64,6.15,1.5,12.34,2.56,18.4a3.71,3.71,0,0,1-7.24,1.6l-.06-.31c-1.1-6.24-2-12.61-2.63-18.93a3.71,3.71,0,0,1,3.31-4.07h.42a3.7,3.7,0,0,1,3.64,3.29Zm6.45,36.57c1.5,6,3.25,12,5.19,17.84a3.71,3.71,0,0,1-7,2.33c-2-6-3.79-12.2-5.34-18.36a3.71,3.71,0,0,1,2.68-4.5h0a3.36,3.36,0,0,1,.94-.11,3.7,3.7,0,0,1,3.52,2.78Zm11.67,35.25c2.36,5.7,5,11.39,7.74,16.92a3.71,3.71,0,0,1-6.63,3.32c-2.86-5.68-5.53-11.53-8-17.4a3.73,3.73,0,0,1,2-4.85,4,4,0,0,1,1.45-.28,3.74,3.74,0,0,1,3.44,2.27Zm16.68,33.2c3.16,5.29,6.57,10.55,10.11,15.61a3.7,3.7,0,0,1-6,4.26c-3.65-5.21-7.15-10.61-10.4-16.05a3.71,3.71,0,0,1,1.28-5.09h0a3.71,3.71,0,0,1,5.06,1.25Zm21.32,30.43c3.88,4.76,8,9.47,12.26,14a3.71,3.71,0,0,1-5.4,5.08c-4.37-4.64-8.62-9.48-12.61-14.38a3.71,3.71,0,0,1,.54-5.22h0a3.8,3.8,0,0,1,2.37-.83,3.7,3.7,0,0,1,2.84,1.33Zm25.48,27c4.53,4.15,9.28,8.22,14.13,12.07a3.71,3.71,0,1,1-4.44,5.95l-.17-.14c-5-4-9.88-8.15-14.53-12.42A3.71,3.71,0,1,1,1650,454a2.82,2.82,0,0,1,.36.33Zm29.09,23.09c5.07,3.46,10.35,6.8,15.71,9.92a3.71,3.71,0,0,1-3.73,6.41c-5.51-3.21-11-6.65-16.16-10.2a3.71,3.71,0,0,1,4.12-6.18l.06.05Zm269.85,16.1a3.7,3.7,0,0,1-1.53,5c-5.6,3-11.39,5.8-17.2,8.37a3.71,3.71,0,0,1-3-6.79c5.64-2.48,11.26-5.22,16.71-8.12a3.52,3.52,0,0,1,1.77-.44,3.68,3.68,0,0,1,3.25,2ZM1711.55,496c5.55,2.71,11.26,5.24,17,7.53a3.71,3.71,0,1,1-2.76,6.89c-5.87-2.36-11.75-5-17.46-7.76a3.71,3.71,0,1,1,2.92-6.82l.33.16Zm203.52,13.18a3.72,3.72,0,0,1-2.25,4.74c-6,2.13-12.09,4.07-18.23,5.77a3.71,3.71,0,0,1-2-7.14c6-1.66,11.93-3.54,17.72-5.61a3.52,3.52,0,0,1,1.28-.22,3.71,3.71,0,0,1,3.48,2.48Zm-169.08.64c5.89,1.88,11.91,3.56,17.89,5a3.71,3.71,0,1,1-1.73,7.22c-6.16-1.48-12.35-3.21-18.41-5.15a3.71,3.71,0,0,1,1.16-7.24,3.67,3.67,0,0,1,1.09.19Zm132.9,9.94a3.7,3.7,0,0,1-2.91,4.36c-6.23,1.25-12.58,2.28-18.88,3.08a3.71,3.71,0,0,1-.92-7.36c6.12-.78,12.29-1.78,18.34-3a4,4,0,0,1,.77-.07,3.7,3.7,0,0,1,3.6,3Zm-96.8-1.27c6.08,1,12.28,1.78,18.43,2.34a3.71,3.71,0,0,1-.29,7.41,2.43,2.43,0,0,1-.38,0c-6.33-.57-12.71-1.38-19-2.41a3.7,3.7,0,0,1,.63-7.36,2.48,2.48,0,0,1,.61.07Zm59.47,6.5a3.7,3.7,0,0,1-3.5,3.91h0c-5.61.3-11.31.43-16.93.37h-2.2a3.71,3.71,0,0,1,.11-7.41h2.12c5.47,0,11-.07,16.46-.37h.24a3.7,3.7,0,0,1,3.7,3.52Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1970.28,476.9a3.75,3.75,0,0,0-2.12.64q-3.77,2.56-7.63,5a3.72,3.72,0,0,0,4,6.27q4-2.51,7.85-5.15a3.71,3.71,0,0,0-2.06-6.77Z",
    transform: "translate(-50.73 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2080.22,307a3.71,3.71,0,0,0-3.69,3.06q-.78,4.5-1.74,9a3.71,3.71,0,0,0,7.26,1.55c.65-3.06,1.25-6.13,1.79-9.23a3.71,3.71,0,0,0-3-4.29A3.2,3.2,0,0,0,2080.22,307Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1833,1.72c6.27.21,12.58.65,18.76,1.3a3.71,3.71,0,0,1,3.31,4.07,3.65,3.65,0,0,1-4,3.31h-.1c-6-.63-12.15-1.05-18.24-1.26a3.71,3.71,0,0,1,.16-7.41Zm-15,3.61a3.7,3.7,0,0,1-3.57,3.84c-1.94.07-3.88.16-5.84.29-4.13.24-8.3.59-12.41,1a3.71,3.71,0,1,1-1.12-7.33l.33,0c4.22-.46,8.51-.81,12.76-1.07q3-.18,6-.29h.17A3.7,3.7,0,0,1,1818,5.28Zm52.36.32c6.17,1.1,12.35,2.43,18.39,4a3.71,3.71,0,0,1-1.82,7.19c-5.87-1.48-11.88-2.78-17.87-3.85a3.7,3.7,0,0,1,.68-7.35,4.82,4.82,0,0,1,.65,0Zm-89.26,3.07a3.72,3.72,0,0,1-3,4.31c-6,1.08-12,2.38-17.87,3.88a3.71,3.71,0,0,1-1.83-7.19c6-1.54,12.23-2.88,18.39-4a4.14,4.14,0,0,1,.7-.06A3.71,3.71,0,0,1,1781.11,8.72Zm125.72,6.09c5.91,2,11.83,4.16,17.62,6.55a3.71,3.71,0,0,1-2.83,6.85c-5.62-2.32-11.38-4.46-17.13-6.36a3.71,3.71,0,0,1,1.21-7.23,4.26,4.26,0,0,1,1.13.21ZM1745,17.37a3.69,3.69,0,0,1-2.33,4.68h0c-5.77,1.92-11.54,4.07-17.13,6.4a3.71,3.71,0,0,1-2.84-6.85c5.75-2.39,11.69-4.61,17.63-6.59a3.83,3.83,0,0,1,1.21-.19,3.71,3.71,0,0,1,3.48,2.56Zm196.52,11.77c5.57,2.78,11.13,5.81,16.51,9a3.71,3.71,0,0,1-3.45,6.57l-.32-.19c-5.24-3.09-10.63-6-16-8.73a3.71,3.71,0,0,1,1.69-7,3.63,3.63,0,0,1,1.62.37Zm-231,2a3.7,3.7,0,0,1-1.61,5l0,0c-5.43,2.73-10.82,5.69-16,8.79a3.71,3.71,0,0,1-3.79-6.38c5.37-3.19,10.92-6.23,16.51-9a3.77,3.77,0,0,1,5,1.56Zm263.33,17.19c5.15,3.57,10.23,7.35,15.08,11.24a3.71,3.71,0,0,1-4.64,5.79c-4.72-3.79-9.65-7.47-14.66-10.94a3.7,3.7,0,0,1,2.15-6.75,3.6,3.6,0,0,1,2.09.63Zm29.33,23.53c4.59,4.26,9.08,8.72,13.34,13.26a3.71,3.71,0,1,1-5.21,5.28l-.2-.21c-4.14-4.41-8.5-8.75-13-12.89a3.71,3.71,0,0,1,5-5.44Zm25.71,27.44c3.94,4.86,7.75,9.92,11.33,15a3.71,3.71,0,0,1-6.08,4.25c-3.47-5-7.18-9.89-11-14.61a3.71,3.71,0,0,1,5.76-4.67Zm21.57,30.82c3.21,5.38,6.26,10.93,9.08,16.5A3.71,3.71,0,0,1,2053,150c-2.73-5.41-5.71-10.81-8.83-16a3.71,3.71,0,0,1,1.28-5.09h0a3.66,3.66,0,0,1,1.93-.52,3.72,3.72,0,0,1,3.18,1.74Zm17,33.6c2.41,5.77,4.63,11.7,6.62,17.61a3.71,3.71,0,1,1-7,2.36c-1.93-5.75-4.1-11.5-6.44-17.11a3.71,3.71,0,1,1,6.85-2.86h0Zm12,35.65c1.56,6,2.91,12.23,4,18.38a3.71,3.71,0,1,1-7.27,1.47l0-.15c-1.09-6-2.41-12-3.92-17.85a3.7,3.7,0,0,1,2.66-4.51h0a4.27,4.27,0,0,1,1-.12,3.7,3.7,0,0,1,3.49,2.75Zm6.76,37c.48,4.45.87,8.95,1.13,13.4.11,1.78.19,3.57.26,5.35a3.7,3.7,0,0,1-7.4.36v-.06c-.08-1.74-.16-3.47-.26-5.21-.26-4.32-.63-8.7-1.11-13a3.72,3.72,0,0,1,3.28-4.1h.45a3.73,3.73,0,0,1,3.59,3.21Zm-2.12,33.75a3.71,3.71,0,0,1,3.6,3.82h0c-.19,6.25-.61,12.57-1.25,18.78a3.71,3.71,0,0,1-7.38-.76c.62-6,1-12.17,1.21-18.25a3.71,3.71,0,0,1,3.75-3.59Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1675.28,48.14a3.72,3.72,0,0,0-2.16.66q-3.84,2.7-7.6,5.51a3.71,3.71,0,0,0,4.21,6.11l.24-.18q3.66-2.75,7.4-5.36a3.7,3.7,0,0,0-2.09-6.74Z",
    transform: "translate(-50.73 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1655.63,157a3.13,3.13,0,0,0-.27,3.62l19.7,32.51a165.45,165.45,0,0,0-15.93,51.22l-34.63,15.61a3.13,3.13,0,0,0-1.82,3.13l4.16,45.4a3.13,3.13,0,0,0,2.37,2.75l36.89,9a165.58,165.58,0,0,0,25,47.47l-13.47,35.54a3.13,3.13,0,0,0,.92,3.51l35,29.15a3.1,3.1,0,0,0,3.61.28l32.51-19.7a165.62,165.62,0,0,0,51.22,15.93l15.61,34.63a3.12,3.12,0,0,0,3.13,1.82l45.4-4.16a3.11,3.11,0,0,0,2.75-2.37l9-36.89a165.58,165.58,0,0,0,47.47-25l35.54,13.45a3.1,3.1,0,0,0,3.51-.92L1992.46,378a3.12,3.12,0,0,0,.27-3.61L1973,341.84A165.45,165.45,0,0,0,1989,290.62L2023.63,275a3.13,3.13,0,0,0,1.83-3.13l-4.17-45.4a3.12,3.12,0,0,0-2.37-2.75l-36.89-9a165.34,165.34,0,0,0-25-47.47l13.49-35.56a3.1,3.1,0,0,0-.92-3.51l-35-29.16a3.13,3.13,0,0,0-3.62-.27l-32.51,19.7a165.45,165.45,0,0,0-51.22-15.93l-15.62-34.66a3.13,3.13,0,0,0-3.13-1.83l-45.4,4.17a3.12,3.12,0,0,0-2.75,2.37l-9,36.88a165.71,165.71,0,0,0-47.47,25L1688.34,121a3.12,3.12,0,0,0-3.51.93Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1830.91,223.83a44,44,0,1,1-6.53-.54A44.59,44.59,0,0,1,1830.91,223.83Zm14.8,73.38a36.78,36.78,0,0,0-16-66h0a36.77,36.77,0,0,0-11.41,72.65,35.44,35.44,0,0,0,5.44.45,36.42,36.42,0,0,0,21.92-7.05Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1825.91,154.45a114.26,114.26,0,0,0-11.55.47h0l-.52.05a113.72,113.72,0,0,0-22.81,4.57l-.41.13a3.71,3.71,0,0,0-2.6,3.49,4.05,4.05,0,0,0,.17,1.15,3.71,3.71,0,0,0,4.65,2.43,106.39,106.39,0,0,1,22.2-4.43h.08a106.3,106.3,0,1,1-96.23,115.57c-.33-3.6-.47-7.2-.44-10.79a105.84,105.84,0,0,1,10.46-44.94,3.57,3.57,0,0,0,.36-1.57,3.71,3.71,0,0,0-3.68-3.74,3.75,3.75,0,0,0-3.37,2.1,113.74,113.74,0,1,0,103.69-64.48Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M666.4,2691.94c-35.95,3.11-98.34,8.16-147.52,10.32-29.57,1.3-46.59-1.59-56.39-5.52q0,1.66.09,3.12a10.16,10.16,0,0,0,9.66,9.61c92.94,5.19,166.86,1.8,193.17.2a7.24,7.24,0,0,0,5.9-10.89A58.83,58.83,0,0,0,666.4,2691.94Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.88,2702.26c49.18-2.16,111.57-7.21,147.52-10.32-35.34-43.36-147.52-72.59-147.52-72.59H487.19c-21.79,31.42-24.94,61.32-24.7,77.39C472.29,2700.72,489.31,2703.56,518.88,2702.26Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M481.86,2567.63l3,58.67a13.39,13.39,0,0,0,11.44,12.6,52,52,0,0,0,23.8-2,15.82,15.82,0,0,0,10.62-12.18L541,2567.6Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.13,2759.63c-15.59-2.81-22.64-13.28-25.6-24.47l-.06.3a27.9,27.9,0,0,0,13.65,29.86c12.85,7,26.9,8.23,37.81,7.65a35,35,0,0,0,28.34-16.9l.09-.15C156.63,2763.43,140.13,2764.31,114.13,2759.63Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.63,2585.72H161.5c-39.8-1-64.79,107.44-73,149.45,3,11.19,10,21.66,25.6,24.47,26,4.68,42.48,3.8,54.23-3.71,21.5-36.57,32.16-90.13,37.29-121.39C211.47,2599,187.63,2585.72,187.63,2585.72Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M164.86,2531.25,150.35,2589a15.67,15.67,0,0,0,8.15,17.76c8.12,4.16,19.54,8.54,30,7.27a13.05,13.05,0,0,0,10.67-8.72l21.3-60.72Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.25,1771.21s-129.62,810.51-127.52,814.94c0,0-35.81,16.28-74.85,2.07,0,0,11.72-433.26,39.2-599.38,0,0-221.29,387.25-291.56,580.21,0,0-36.65-4.37-67-24.34,0,0,238.26-697,301.83-789.87Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "467.91 1981.66 515.99 1904.86 550.96 1897.82 550.32 1894.63 513.97 1901.94 465.14 1979.93 467.91 1981.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1270.25,977.58s-87.49,19.29-140.7,43.86a48.65,48.65,0,0,0-23.8,23.93c-15.92,34.87-63.54,122.29-155.88,164,13.3,17.65,34.71,54.37,44,116.08,55.46-41.28,103.34-110.22,126.33-223.29,0,0,17.51,9.52,39.34-1.09,11.54-5.6,24.86-13.55,34.86-19.8a45.63,45.63,0,0,0,20.27-27.22c3.81-14.93,1.56-28.06,1.56-42.14l45-13.93S1274.77,992.88,1270.25,977.58Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M993.91,1325.46c-9.33-61.71-30.74-98.43-44-116.08-57.37,25.92-132,34.2-227,1.28a100.68,100.68,0,0,0-27.16-5.36c-50.59-3-217.29-8.38-355.23,37.19a107.28,107.28,0,0,0-64.66,58.86c-37.31,85.63-97.72,280.64,70,379.1a416.06,416.06,0,0,1,40.48-76.6c-27-45.55-35-107.77,12.92-188.8,34.94,94.37,51.34,232,54.76,293a131,131,0,0,1-10.26,58.61l-.86,2a7,7,0,0,0,4.87,9.47c94.42,21.2,192.61,15.44,222,13a12.09,12.09,0,0,0,10.79-9.24c45.91-193.45,46-325.41,34.77-408.82C758.16,1382.72,889.48,1403.18,993.91,1325.46Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M681.89,1255.58s22.46,35.4,33.51,118.89Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M482.41,1092.61s-9.56,101-18,130.86a10.2,10.2,0,0,0,4.81,11.66c14.27,8.16,48.5,21.46,95.32-1.49a21.25,21.25,0,0,0,11.8-20l-4.13-97.59Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M574.31,963.42s30.55,70.17,32.6,107,10,60.73-32.6,68.15-78.46-13.8-97.9-50.49c0,0-30.45-56.54-23.62-79.69S574.31,963.42,574.31,963.42Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M491,1061.72l2.43-1.07a5.86,5.86,0,0,0,3-7.72l-.14-.28c-6-11.61-17.71-38.2-2.59-44.4,19.5-8,96.71-23.74,113.36-51.13,16-26.33,1.83-60.32-19.49-70a2.94,2.94,0,0,0-3.84,1.25l-1.78,3.35a2.89,2.89,0,0,1-5.34-.54h0a2.88,2.88,0,0,0-5.21-.75c-5.12,8.2-18.94,21.48-55.91,28.31-52.54,9.69-87.28,31-88.14,67.26a2.9,2.9,0,0,1-4.48,2.39c-3.88-2.36-10.09-3.47-18.39,3.5-14.42,12.14-8.52,43.61,23.11,69.5a2.87,2.87,0,0,1,.5,4,2.82,2.82,0,0,1-.64.6c-5.73,3.73-14.28,12.62,7.87,24.46,22.91,12.25,40,11.24,46.61,10.15a2.89,2.89,0,0,0,2.38-3.31,1,1,0,0,0,0-.17l-7-31.91a2.91,2.91,0,0,1,2.23-3.45,3.05,3.05,0,0,1,.6-.06Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M492.29,1068.44s-11.66-44.83-31.76-32.26,10.43,50.23,26.59,51.91Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1143.63,1091.27a3.36,3.36,0,0,1-2.6-5.47c3.3-4.06,32.61-39.9,43.84-46.25,4.3-2.42,6.76-4.86,7.32-7.24a6.24,6.24,0,0,0-.7-4.25l-35,7-19.64,16.85a3.35,3.35,0,1,1-4.37-5.09l20.31-17.42a3.43,3.43,0,0,1,1.53-.75l38.19-7.65a3.33,3.33,0,0,1,3.43,1.41c2.73,4,3.63,7.78,2.77,11.43-1,4.34-4.47,8.11-10.55,11.54-8.57,4.85-33.18,33.87-41.94,44.64A3.31,3.31,0,0,1,1143.63,1091.27Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M491.43,1749.41l137.85-3s-120.21-34-127.65-24.69c0,0-74.51-49-115.34-117.84a416.06,416.06,0,0,0-40.48,76.6C382.4,1701.94,430.47,1739.27,491.43,1749.41Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M487.54,1725.54s-2.84,54.93,69.26,47c39.18-4.33,102.44-40.87,102.44-40.87S494.35,1731.19,487.54,1725.54Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M515.77,1740.28h.79l342.76-.37a15.18,15.18,0,1,0,0-30.36h0l-342.76.37a15.18,15.18,0,0,0-.76,30.34Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1167.45,1432.36H882a54.44,54.44,0,0,0-49.2,30.87l-132,276.87h354.75a33.08,33.08,0,0,0,30.75-20.69l102.34-256.21C1194.56,1448.4,1183.54,1432.36,1167.45,1432.36Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M966.34,1574.32c-6.18,19-1.61,37.48,10.21,41.25s26.42-8.6,32.61-27.62,1.61-37.48-10.21-41.24S972.53,1555.3,966.34,1574.32Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1300.21,212.36a5.22,5.22,0,0,1-5.07-5.16C1294.62,178.34,1285.72,35,1161,5,1022.23-28.28,958.71,114.62,958.71,114.62S787,47.92,754,226.62c-107.69,26.1-135.67,168.5-65.63,238.1A59.82,59.82,0,0,0,730,482.16l674.42,6.15a44.46,44.46,0,0,0,43-32.15C1468.49,384.15,1496.1,217,1300.21,212.36Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1284.79,215.42a5.24,5.24,0,0,1-5.07-5.14c-.55-27.69-9.35-160.6-126.79-188.46-131.25-31.1-191.3,102.32-191.3,102.32S799.21,61.86,768.07,228.72C667.21,252.89,640.3,383.55,704.13,449.17a59.86,59.86,0,0,0,42.38,18.19l634.88,5.72a44.47,44.47,0,0,0,43-32.27C1444.19,372.44,1467.68,219.85,1284.79,215.42Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M982.1,161l51.95-2.1a4.18,4.18,0,0,1,4.34,4h0l6.91,171.39h0l-60,2.42h0l-6.92-171.67A3.9,3.9,0,0,1,982.1,161Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M967.85,334.06s36.72,65.06,49.12,84.77a3.88,3.88,0,0,0,6.81-.45l40.7-87.71c1.45-2.58.1-6.65-2.18-6.56l-92.52,3.74C967.7,327.93,966.63,331.49,967.85,334.06Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1151.06,419.85l-52,.76a4.17,4.17,0,0,1-4.23-4.11h0L1092.32,245h0l60.07-.88h0l2.52,171.77A3.92,3.92,0,0,1,1151.06,419.85Z",
    transform: "translate(-50.73 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1169.77,247.19s-35-66-46.92-86a3.9,3.9,0,0,0-6.83.28l-42.94,86.63c-1.52,2.55-.27,6.65,2,6.61l92.59-1.35C1169.77,253.32,1171,249.79,1169.77,247.19Z",
    transform: "translate(-50.73 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItImg3);
export default __webpack_public_path__ + "static/media/it_img_3.73dd46981d8f3b8ef9af3f4e91c68b32.svg";
export { ForwardRef as ReactComponent };